import styled from 'styled-components';
import { ACTIONS, BUTTON_TYPES, trackButtonClicked } from '@/utils/track';
import { createSignInURL } from '@/utils/onboarding-urls';

const AccessAccount = styled.div`
  display: flex;
  margin: 16px 0 0;
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    margin: 16px 0 0;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.max_xs}px) {
    flex-direction: column;
    margin: 24px 0 8px;
  }
`;
const AccessAccountText = styled.p`
  color: ${(props) => props.theme.colors.grey[800]};
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
`;
const AccessAccountLink = styled.a`
  color: ${(props) => props.theme.colors.grey[800]};
  font-weight: 500;
  font-size: 16px;
  text-decoration: underline;
  line-height: 28px;
  margin-left: 4px;
  @media (max-width: ${(props) => props.theme.breakpoints.max_xs}px) {
    margin-left: 0;
  }
`;

const LinkAccount = ({ client, selectClientCountry, url, id }) => {
  const signInUrl = createSignInURL(
    url,
    {
      unit: client?.product?.key === 'thrive' ? 'dpt' : client?.product?.key,
      program_type: client?.product?.param,
      hide_get_started: true,
      client_ref: client?.institutionKey ?? client?.clientKey,
    },
    selectClientCountry?.country?.key,
  );
  return (
    <AccessAccount>
      <AccessAccountText id={`${id}-text`}>Already have an account?</AccessAccountText>
      <AccessAccountLink
        id={id}
        href={signInUrl}
        passHref
        onClick={() => {
          trackButtonClicked({
            action: ACTIONS.REDIRECT_TO_SIGN_IN,
            buttonLocation: 'header',
            buttonText: ' Sign in here',
            buttonType: BUTTON_TYPES.NAVIGATION,
            destination: signInUrl,
            page_title: '',
          });
        }}
      >
        Sign in here
      </AccessAccountLink>
    </AccessAccount>
  );
};

export default LinkAccount;
